import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";

export const Route = createFileRoute("/auth")({
  head: () => ({
    meta: [
      { title: "Inloggen bij De Hussel App | Tennis hussel-indelingen" },
      { name: "description", content: "Log in bij De Hussel App om deel te nemen aan husselavonden bij je tennisclub. Meld je aan voor sessies en bekijk je baanindeling." },
      { property: "og:title", content: "Inloggen bij De Hussel App | Tennis hussel-indelingen" },
      { property: "og:description", content: "Log in bij De Hussel App om deel te nemen aan husselavonden bij je tennisclub. Meld je aan voor sessies en bekijk je baanindeling." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/auth" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/auth" }],
  }),
  component: Auth,
});
